import { Box, Button, Flex, Image, Stack } from '@chakra-ui/react';

import { Link as DefaultLink } from 'react-router-dom';
import Image404 from '../../theme/assets/404-error.svg';
import React from 'react';

export const NotFound = () => {
    return (
        <>
            <Flex
                minH={'-webkit-fill-available'}
                align={'center'}
                justify={'center'}
                py={10}
            >
                <Stack alignItems={'center'}>
                    <Box boxSize={'sm'} height={'auto'}>
                        <Image src={Image404} alt='404 page' />
                    </Box>
                    <Button colorScheme={'yellow'} as={DefaultLink} to='/' w={'min-content'}>Back to Homepage</Button>
                </Stack>
            </Flex>
        </>
    );
};